export default __webpack_public_path__ + "static/media/D.64d0727f.svg";